const SCAN_QR = '/ScanQR';
const LIST = '/List';
const HOME = '/Home';

/**
 * Browser back is trapped in initAppSettings and replaced by an in-app route.
 * Cross-device is a single document: List is not a valid destination.
 * That exit matches in-app back (Scan QR).
 */
export function resolveBrowserBackAction({
  crossDeviceMode,
  routerUrl,
  skipListMode,
  skipStartPage,
  actionsOpen,
  popupOpen,
  sheetOpen,
  embedMode
}) {
  if (actionsOpen) return 'close-actions';
  if (popupOpen) return 'close-popup';
  if (sheetOpen) return 'close-sheet';
  if (embedMode) return 'embed-parent';
  if (crossDeviceMode) {
    return routerUrl === SCAN_QR ? 'stay' : 'cross-device-back';
  }
  if ((routerUrl === LIST || skipListMode) && !skipStartPage) {
    return 'home';
  }
  if (routerUrl !== HOME) return 'list';
  return 'stay';
}
